import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["intervalSelect", "weeklyDay", "monthlyDay"]

  declare intervalSelectTarget: HTMLSelectElement
  declare weeklyDayTarget: HTMLElement
  declare monthlyDayTarget: HTMLElement

  connect() {
    this.update()
  }

  update() {
    const interval = this.intervalSelectTarget.value

    // Hide all conditional fields initially
    this.weeklyDayTarget.classList.add("hidden")
    this.monthlyDayTarget.classList.add("hidden")

    // Show the appropriate field based on interval
    if (interval === "weekly") {
      this.weeklyDayTarget.classList.remove("hidden")
    } else if (interval === "monthly") {
      this.monthlyDayTarget.classList.remove("hidden")
    }
  }
}
